import { call, put, takeLatest, all, fork, takeEvery } from 'redux-saga/effects';
//Include Both Helper File with needed methods
import {
	BOOKING_LIST_LOADING,
	GET_BOOKING_DETAIL_DATA_LOADING,
	BOOKING_FILTER_DATA_LOADING,
	CONTAINERS_LIST_LOADING,
	BOOKING_DOCUMENT_LOADING
} from './actionTypes';

import {
	// Get All Bookings
	getAllBookingData,
	getAllBookingDataError,
	getBookingDetailDataSuccess,
	getBookingDetailDataError,

	// Get Booking Filter
	getBookingFilterData,
	getBookingFilterDataError,

	// Get Booking Containers
	getBookingContainersSuccess,
	getBookingContainersError,

	// Get Booking Document
	// Get Booking Document
	getBookingDocumentSuccess,
	getBookingDocumentError
} from './actions';

import {
	getAllBookingDataBasedOnSelectedMonthAPI,
	getBookingContainersListAPI,
	getBookingDetailDataAPI,
	getBookingFilterDataValuesAPI,
	getBookingDocumentDataAPI
} from './helper';

/*
 * Get All Bookings
 */
function* getAllBookingDatagenerator(payload) {
	try {
		let selectedFilters = payload?.payload || {};
		var response = yield call(getAllBookingDataBasedOnSelectedMonthAPI, { ...selectedFilters });
		yield put(getAllBookingData(response?.bookingData));
	} catch (error) {
		yield put(getAllBookingDataError(error));
	}
}

/*
 * Get Booking Filter Data
 */
function* getBookingFilterDataValue(payload) {
	try {
		let selectedFilters = payload?.payload;
		var response = yield call(getBookingFilterDataValuesAPI, { ...selectedFilters });
		yield put(getBookingFilterData(response?.filters));
	} catch (error) {
		yield put(getBookingFilterDataError(error));
	}
}
/*
 * Get Booking Detail
 */
function* getBookingDetailData({ payload }) {
	try {
		let { bookingId } = payload;
		var response = yield call(getBookingDetailDataAPI, bookingId);
		yield put(getBookingDetailDataSuccess(response?.bookingData));
	} catch (error) {
		yield put(getBookingDetailDataError(error));
	}
}

/*
 * Get Booking Containers
 */
function* getBookingContainers({ payload }) {
	try {
		let { bookingId } = payload;
		var response = yield call(getBookingContainersListAPI, { bookingId });
		yield put(getBookingContainersSuccess(response?.bookingContainers));
	} catch (error) {
		yield put(getBookingContainersError(error));
	}
}
/*
 * Get Booking Document
 */
function* getBookingDocument({ payload }) {
	try {
		let { bookingId } = payload;
		var response = yield call(getBookingDocumentDataAPI, bookingId);
		yield put(getBookingDocumentSuccess(response?.bookingDocuments));
	} catch (error) {
		yield put(getBookingDocumentError(error));
	}
}

function* watchAllBookingsEndpoints() {
	yield takeLatest(BOOKING_LIST_LOADING, getAllBookingDatagenerator);
	yield takeLatest(GET_BOOKING_DETAIL_DATA_LOADING, getBookingDetailData);
	yield takeLatest(BOOKING_FILTER_DATA_LOADING, getBookingFilterDataValue);
	yield takeLatest(CONTAINERS_LIST_LOADING, getBookingContainers);
	yield takeLatest(BOOKING_DOCUMENT_LOADING, getBookingDocument);
}

export default function* rootSaga() {
	yield all([fork(watchAllBookingsEndpoints)]);
}
